import React from 'react';

import DefaultView from '../../reusable/DefaultView/DefaultView';

const SurveyAnswerView = function () {
  return (
    <DefaultView/>
  )
};

export default SurveyAnswerView;